import UsuariosLista from '@/pages/sistema/usuarios/UsuariosLista'
import UsuariosForm from '@/pages/sistema/usuarios/UsuariosForm'
import UsuariosPermissoes from '@/pages/sistema/usuarios/UsuariosPermissoes'

export default [
  {
    path: '/sistema/usuarios', 
    name: 'UsuariosLista', 
    component: UsuariosLista,
    meta: {layout: 'principal', permissao: 'usuarios_acessar'}
  },
  
  {
    path: '/sistema/usuarios/adicionar', 
    name: 'UsuariosAdicionar', 
    component: UsuariosForm,
    meta: {layout: 'principal', permissao: 'usuarios_adicionar'}
  },
  
  {
    path: '/sistema/usuarios/:id/editar', 
    name: 'UsuariosEditar', 
    component: UsuariosForm,
    meta: { layout: 'principal', permissao: 'usuarios_editar'}
  },

  {
    path: '/sistema/permissoes', 
    name: 'Permissoes', 
    component: UsuariosPermissoes,
    meta: {layout: 'principal', permissao: 'permissoes_acessar'}
  },
];
